// CustomSideNav.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  useMediaQuery,
  List,
  ListItemIcon,
  Divider,
  Tooltip,
  ListItemButton,
  Skeleton,
} from "@mui/material";
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import { attendanceIcon, careIqIcon, communicationIcon, homeIcon, InventoryIcon, NavArrowIcon, onboard, onboardIcon, patientIcon, Reports, RPMIcon, schedulerIcon, signInIcon, taskIcon, userIcon, waitingRoom } from "./svgslist";
import { clearPrivileges } from "../reduxtoolkit/userPrivileges";
import uiConfig from "../utils/previlagecodes";
import { flag } from "../landingscreen/landingsvgs";
import FlagModal from "../landingscreen/modals/flagmodal";
import { useRecording } from "../context/RecordingContext";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import PaymentIcon from '@mui/icons-material/Payment';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
const WIDTH_EXPANDED = 240;
const WIDTH_COLLAPSED = 68;
const ITEM_HEIGHT = 40;
const HEADER_H = 65;

const CustomSideNav = ({ isCollapsed, setIsCollapsed }) => {
  const { isGlobalRecording } = useRecording();
  const privileges = useSelector((state) => state.userPrivileges.privileges);
    const dispatch = useDispatch();
  const miniSidenav = isCollapsed;
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate();
  const location = useLocation();
  const [supportmodal,setSupportModal]=useState(false)
const queryParams = useMemo(() => new URLSearchParams(window.location.search), []);
const allowToken = queryParams.get('allowtoken');
const sbParam = queryParams.get('sb');
let allowedCodes = [];
if (allowToken && sbParam) {
  allowedCodes = sbParam.split(','); // split multiple codes
}
  useEffect(() => {
    setIsCollapsed(isMobile);
  }, [isMobile, setIsCollapsed]);

  const handleCollapse = () => setIsCollapsed((prev) => !prev);

  const handleLogout = () => {
    localStorage.removeItem("auth");
    window.clearPracticeSession && window.clearPracticeSession();
    dispatch(clearPrivileges());
    navigate("/sign-in/");
  };

  // ✅ Give each item a path so we can mark it active
  const navItems = [
    {
      label: "Home",
      privilege: "",
      icon: homeIcon,
      path: "/landing",
      onClick: () => {
        navigate("/landing");
        if (!isGlobalRecording) window.location.reload();
      },
    },
    {
      label: "Sign-in",
      privilege: "SignIn Sheet",
      icon: signInIcon,
      path: "/signtab",
      onClick: () => navigate("/signtab"),
    },
    {
      label: "Print Notes",
      privilege: "",
      icon: <><LocalPrintshopOutlinedIcon /></>,
      path: "/print-notes",
      onClick: () => navigate("/print-notes"),
    },
    {
      label: "Communication",
      privilege: "Communication",
      icon: communicationIcon,
      path: "/fax",
      onClick: () => navigate("/fax"),
    },
    {
      label: "Attendance",
      privilege: "Attendence",
      icon: attendanceIcon,
      path: "/timesheets",
      onClick: () => navigate("/timesheets"),
    },
    {
      label: "Onboard",
      privilege: "Onboarding",
      icon: onboard,
      path: "/onboarding",
      onClick: () => navigate("/onboarding"),
    },
    // {
    //   label: "Patient",
    //   privilege: "",
    //   icon: patientIcon,
    //   path: "/patient",
    //   onClick: () => navigate("/patient"),
    // },
    {
      label: "RPM",
      privilege: "RPM",
      icon: RPMIcon,
      path: "/rpm",
      onClick: () => navigate("/rpm"),
    },
    {
      label: "User",
      privilege: "Users",
      icon: userIcon,
      path: "/user",
      onClick: () => navigate("/user"),
    },
    // {
    //   label: "Waiting Room",
    //   privilege: "",
    //   icon: waitingRoom,
    //   path: "/waiting-room",
    //   onClick: () => navigate("/waiting-room"),
    // },
    {
      label: "Reports",
      privilege: "Reports",
      icon: Reports,
      path: "/reports",
      onClick: () => navigate("/reports"),
    },

    // {
    //   label: "Tasks",
    //   privilege: "Tasks",
    //   icon: taskIcon,
    //   path: "/tasks",
    //   onClick: () => navigate("/tasks"),
    // },
    {
      label: "Scheduler",
      privilege: "Scheduler",
      icon: schedulerIcon,
      path: "/schedule",
      onClick: () => navigate("/schedule"),
    },
    {
      label: "Inventory",
      privilege: "Inventory",
      icon: InventoryIcon,
      path: "/inventory",
      onClick: () => navigate("/inventory"),
    },
    {
      label: "Logs",
      privilege: "Logs",
      icon:<><PhoneAndroidIcon/></> ,
      path: "/logs",
      onClick: () => navigate("/logs"),
    },
    {
      label: "Prices",
      privilege: "Prices",
      icon:<><PaymentIcon/></> ,
      path: "/prices",
      onClick: () => navigate("/prices"),
    },

    // {
    //   label: "CareIq",
    //   privilege: "",
    //   icon: careIqIcon,
    //   path: "/careiq",
    //   onClick: () => navigate("/careiq"),
    // },
    {
      label: "Colour Coding",
      privilege: "Colorcode",
      icon: <ColorLensOutlinedIcon />,
      path: "/colorcode",
      onClick: () => navigate("/colorcode"),
    },
  
    
    {
      label: "Support",
      privilege: "",
      icon: flag,
      path: "/log",
    onClick: () => {
      setSupportModal(true)
      }
    },
    {
      label: "Logout",
      privilege: "",
      icon: <LogoutOutlinedIcon />,
      path: "/logout",
      onClick: handleLogout,
    },
  ];

  // const filteredNavItems = navItems.filter(
  //   (i) => !i.privilege || privileges.includes(i.privilege)
  // );
  const filteredNavItems = navItems.filter((item) => {
  // normal flow: no allowtoken
  if (!allowToken) {
    return !item.privilege || privileges.includes(item.privilege);
  }

  // special flow: allowtoken + sb param
  if (allowToken && allowedCodes.length > 0) {
    const configItem = uiConfig.find(cfg => cfg.item === 'sidebar');
    if (!configItem) return false;

    const matched = configItem.items.find(
      (i) => i.label === item.label && allowedCodes.includes(i.code)
    );
    return Boolean(matched);
  }

  // allowtoken present but no sb param → hide all
  return false;
});
const bottomCodes = ['SUP',"HCC", "HLO",]; // codes for Colour Coding and Logout
const bottomItems = filteredNavItems.filter((item) =>
  bottomCodes.includes(uiConfig[0].items.find((i) => i.label === item.label)?.code)
);

const topItems = filteredNavItems.filter((item) => !bottomItems.includes(item));


  const Container = ({ children }) => (
    <div
      id="custom-sidenav"
      className="fixed z-40 left-0 rounded-b-xl shadow-[0_14px_42px_rgba(0,0,0,0.06)] bg-[#FAFAF9] flex flex-col items-stretch"
      style={{
        top: HEADER_H,
        width: miniSidenav ? WIDTH_COLLAPSED : WIDTH_EXPANDED,
        transition: "width 200ms ease",
        borderTopRightRadius: 14,
        borderBottomRightRadius: 14,
        overflow: "visible", // ✅ was "clip"
        overscrollBehavior: "none",
        touchAction: "none",
        height: `calc(100% - ${HEADER_H}px)`,
      }}
    >
      <style>{`
        #custom-sidenav { height: calc(100vh - ${HEADER_H}px); }
        @supports (height: 100dvh) { #custom-sidenav { height: calc(100dvh - ${HEADER_H}px); } }
        @supports (height: 100svh) { #custom-sidenav { height: calc(100svh - ${HEADER_H}px); } }
        #custom-sidenav *::-webkit-scrollbar { display: none; width: 0; height: 0; }
      `}</style>
      {children}
    </div>
  );

  const ToggleButton = () => (
    <button
      type="button"
      aria-label="Toggle sidebar"
      onClick={(e) => {
        e.stopPropagation();
        handleCollapse();
      }}
      onMouseDown={(e) => e.stopPropagation()}
      className=" flex items-center justify-center rounded-md"
      style={{
        position: "absolute",
        top: 16,
        right: -12, // overlap outside nicely
        outline: "none",
        border: "none",
        // backgroundColor: "#E17954",
        touchAction: "manipulation",
        pointerEvents: "auto",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        zIndex: 50, // make sure it shows on top
      }}
    >
      <div
        style={{
          transition: "transform 200ms",
          transform: miniSidenav ? "rotate(180deg)" : "rotate(0deg)",
        }}
      >
        {NavArrowIcon}
      </div>
    </button>
  );

  const Item = ({ icon, label, onClick, path }) => {
    const location = useLocation(); // 👈 add this at top of file
    const isActive =
      path === "/logout"
        ? false
        : location.pathname === path ||
          location.pathname.startsWith(path + "/");

    const content = (
      <ListItemButton
        onClick={onClick}
        disableRipple
        sx={{
          borderRadius: miniSidenav ? "50%" : 28,
          height: ITEM_HEIGHT,
          px: miniSidenav ? 0 : 1,
          mx: miniSidenav ? 1 : 1,
          my: 0.5,
          ...(isActive
            ? {
                backgroundColor: miniSidenav ? "transparent" : "#1D2951",
                "&:hover": {
                  backgroundColor: miniSidenav ? "transparent" : "#1D2951",
                },
              }
            : {
                "&:hover": { backgroundColor: "#F5F5F5" },
              }),
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: miniSidenav ? "auto" : 32,
            mx: miniSidenav ? "auto" : 0,
            color: isActive ? "#FFFFFF" : "#202224",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: miniSidenav ? 0 : 1,
            width: miniSidenav ? 40 : "auto",
            height: miniSidenav ? 40 : "auto",
            borderRadius: miniSidenav ? "50%" : "none",
            backgroundColor:
              miniSidenav && isActive ? "#1D2951" : "transparent",
          }}
        >
          {icon}
        </ListItemIcon>

        {!miniSidenav && (
          <span
            style={{
              fontFamily: "'Font1', sans-serif",
              fontSize: 14,
              color: isActive ? "#FFFFFF" : "#202224",
              fontWeight: 500,
              WebkitFontSmoothing: "antialiased",
              MozOsxFontSmoothing: "grayscale",
              textRendering: "optimizeLegibility",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginLeft: 8,
            }}
          >
            {label}
          </span>
        )}
      </ListItemButton>
    );

    return miniSidenav ? (
      <Tooltip title={label} placement="right">
        <div>{content}</div>
      </Tooltip>
    ) : (
      content
    );
  };

  return (
    <>
      <Container>
        <div className="pt-4" />
        {!miniSidenav && <ToggleButton />}

        <div
          className="flex-1 flex flex-col items-stretch justify-between px-2"
          style={{ minHeight: 0 }}
        >
          {miniSidenav && <ToggleButton />}
          <div className="flex-1 mt-0 overflow-y-auto" style={{ minHeight: 0 }}>
            <List
              dense
              sx={{
                py: 0,
                overflow: "visible",
                msOverflowStyle: "none",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {privileges.length === 0
                ? Array.from({ length: 6 }).map((_, idx) => (
                    <div
                      key={idx}
                      style={{
                        height: ITEM_HEIGHT,
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: miniSidenav ? 8 : 16,
                        paddingRight: 8,
                      }}
                    >
                      <Skeleton variant="circular" width={20} height={20} />
                      {!miniSidenav && (
                        <Skeleton
                          variant="text"
                          width={120}
                          height={14}
                          style={{ marginLeft: 12 }}
                        />
                      )}
                    </div>
                  ))
                : topItems.map((item, i) => (
                    <Item
                      key={`top-${i}`}
                      icon={item.icon}
                      label={item.label}
                      onClick={item.onClick}
                      path={item.path}
                    />
                  ))}
            </List>
          </div>

          <div className="flex-shrink-0">
            <Divider
              sx={{
                mx: miniSidenav ? 1 : 2,
                my: 1,
                // width: "100%",
                borderColor: "#E5E5E5",
                borderWidth: "1px",
              }}
            />

            <div className="px-2 pb-4">
              <List
                dense
                sx={{
                  py: 0,
                  overflow: "visible",
                  msOverflowStyle: "none",
                  scrollbarWidth: "none",
                  width: "100%",
                }}
              >
                {bottomItems.map((item, i) => (
                  <Item
                    key={`bottom-${i}`}
                    icon={item.icon}
                    label={item.label}
                    onClick={item.onClick}
                    path={item.path}
                  />
                ))}
              </List>
            </div>
          </div>
        </div>
      </Container>
<FlagModal
  open={supportmodal}
  onClose={() => setSupportModal(false)}
  onUpdate={({ text, status }) => {
    console.log("Updated flag:", text, status);
    setSupportModal(false); // close after update
  }}
/>

    </>
  );
};

export default CustomSideNav;
